import { DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useProjectResourceAllocationsByIds } from '~/modules/resourcing/common/hooks';
import { useMeContext } from '~/modules/me';
import { RepliconDialog } from '~/modules/common/components';
import { ReleaseAllocationsDialogContent } from './ReleaseAllocationsDialogContent';
import ReleaseAllocationsDialogLoadingContent from './ReleaseAllocationsDialogLoadingContent';
import { ReleaseResourceRequestDialogTitle } from './components';

export const ReleaseAllocationsDialog = ({
  allocatedUser,
  canEditTask,
  onCancelClick,
  onReleaseResourceAllocation,
  onReleaseSuccess,
  open,
  projectUri,
  selectedAllocationId
}) => {
  const {
    featureFlags: { isPsaRmpTaskAllocation1Enabled }
  } = useMeContext();
  const [isFormDirty, setIsFormDirty] = useState(false);

  const allocationIds = allocatedUser.roles.reduce(
    (ids, role) => [
      ...ids,
      ...role.resourceAllocationReference.map(ref => ref.id)
    ],
    []
  );
  const {
    resourceAllocations,
    loadingAllocations
  } = useProjectResourceAllocationsByIds({
    allocationIds
  });

  const checkIsDirty = useCallback(() => isFormDirty, [isFormDirty]);

  return (
    <RepliconDialog
      open={open}
      onClose={onCancelClick}
      disableBackdropClick
      aria-labelledby="release-allocations-dialog-title"
      aria-describedby="release-allocations-dialog-content"
      checkIsDirty={checkIsDirty}
      enableUnsavedChangesWarning
      trapFocusWithDatePicker
    >
      <DialogTitle id="release-allocations-dialog-title">
        <ReleaseResourceRequestDialogTitle
          role={allocatedUser.user}
          onClose={onCancelClick}
          headerId={
            isPsaRmpTaskAllocation1Enabled
              ? 'releaseResourceRequestDialog.releaseResource'
              : 'releaseResourceRequestDialog.releaseAllocationsTitle'
          }
        />
      </DialogTitle>
      {loadingAllocations ? (
        <ReleaseAllocationsDialogLoadingContent onCancelClick={onCancelClick} />
      ) : (
        <ReleaseAllocationsDialogContent
          allocatedUser={allocatedUser}
          allocationIds={allocationIds}
          allocations={resourceAllocations}
          onReleaseSuccess={onReleaseSuccess}
          onReleaseResourceAllocations={onReleaseResourceAllocation}
          projectUri={projectUri}
          onCancelClick={onCancelClick}
          canEditTask={canEditTask}
          selectedAllocationId={selectedAllocationId}
          setIsFormDirty={setIsFormDirty}
        />
      )}
    </RepliconDialog>
  );
};

ReleaseAllocationsDialog.propTypes = {
  allocatedUser: PropTypes.object,
  canEditTask: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onReleaseResourceAllocation: PropTypes.func,
  onReleaseSuccess: PropTypes.func,
  open: PropTypes.bool.isRequired,
  projectUri: PropTypes.string,
  selectedAllocationId: PropTypes.string
};

export default ReleaseAllocationsDialog;
